var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileDocumentCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 17.5L18.5 22.5L15 19L16.5 17.5L18.5 19.5L22 16L23.5 17.5ZM6 2.5C4.89 2.5 4 3.4 4 4.5V20.5C4 21.61 4.89 22.5 6 22.5H13.81C13.45 21.88 13.2 21.2 13.08 20.5H6V4.5H13V9.5H18V13.58C18.33 13.53 18.67 13.5 19 13.5C19.34 13.5 19.67 13.53 20 13.58V8.5L14 2.5M8 12.5V14.5H16V12.5M8 16.5V18.5H13V16.5H8Z",
    fill: "#013BAE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileDocumentCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FileDocumentCheck.dbbc84cd8071a91bd57de71ead44a717.svg";